// src/services/api.js
import axios from 'axios';
import { BASE_URL } from '../config';

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, 
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Attach token to every outgoing request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers['auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor: Catch security errors (401 Unauthorized or 403 Forbidden)
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If the backend says the token is invalid or expired
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.warn("Security Alert: Invalid or expired token. Logging out.");
      localStorage.removeItem('adminToken');
      
      // Force redirect to login page instantly
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default apiClient;